import { getColor } from '@chakra-ui/theme-tools'
import { useTheme } from '@chakra-ui/react'
import { withPrefix } from 'gatsby';
import * as React from 'react'

import { LayoutContext, PageType, isPageType } from '../context/LayoutContext';

const usePageColor = () => {
  const { state } = React.useContext(LayoutContext)

  const theme = useTheme()
  const [color, setColor] = React.useState('#333333')

  const updateColor = React.useCallback((pageType: PageType) => {
    switch (pageType) {
      case '/about/':
        setColor(getColor(theme, 'about.normal'))
        break
      case '/award/':
        setColor(getColor(theme, 'award.normal'))
        break
      case '/entry/':
        setColor(getColor(theme, 'entry.normal'))
        break
      case '/internship/':
        setColor(getColor(theme, 'internship.normal'))
        break
      case '/summit/':
        setColor(getColor(theme, 'summit.normal'))
        break
      case '/event/':
        setColor(getColor(theme, 'event.normal'))
        break
      default:
        setColor(getColor(theme, '#333333'))
        break
    }
  }, [])

  React.useEffect(() => {
    const to = location.pathname
    const prefix = withPrefix('/')
    const path = '/' + to.replace(prefix, '')
    if (isPageType(path)) {
      updateColor(path)
    }
  }, [])

  React.useEffect(() => {
    const transition = state.transitionType
    if (transition && transition.state === 'pageWillAppear') {
      updateColor(transition.to)
    }
  }, [state.transitionType])

  return color
}

export default usePageColor
